import { useCallback } from 'react';

const useXInputValue = ({ type, name, value, defaultValue, onChange }) => {
  const isNumeric = type === 'number';

  const displayValue = (() => {
    if (isNumeric && (value === undefined || value === null)) {
      return defaultValue ?? '';
    }
    return value ?? defaultValue;
  })();

  const handleChange = useCallback(
    (e) => {
      if (!onChange) return;

      if (isNumeric && e.target.value === '') {
        const normalizedEvent = {
          ...e,
          target: { ...e.target, name, value: defaultValue },
        };
        onChange(normalizedEvent);
        return;
      }

      onChange(e);
    },
    [isNumeric, name, defaultValue, onChange],
  );

  return { displayValue, handleChange };
};

export default useXInputValue;
